const ToogleSidebarIcon = ({ size = 20, color = 'currentColor' }) => (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.5 6.66663L9.16667 9.99996M9.16667 9.99996L12.5 13.3333M9.16667 9.99996H16.6667"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M6.66667 4.16663L6.66667 15.8333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
)

export default ToogleSidebarIcon
